import { Navigate, createFileRoute } from "@tanstack/react-router";

import { useUser } from "@/features/auth/hooks/use-user";
import { StaffDashboard } from "@/features/dashboard/modules/staff-dashboard/staff-dashboard";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/today/")({
  loader: () => ({ crumb: m.dashboard_nav_today() }),
  component: CommandCenterPage,
});

/**
 * The team's page, and every request behind it needs `manage:booking`. So the check happens
 * here, before `StaffDashboard` mounts and asks for anything.
 *
 * This app is only for people who run a business on the platform. Someone signed in without
 * booking rights - a client who followed a link here, a team member whose role leaves bookings
 * out - has nothing to do in it, so they are sent to Settings, the one page that is theirs.
 */
function CommandCenterPage() {
  const { user, hasPermission } = useUser();

  if (!hasPermission("manage", "booking")) return <Navigate to="/settings" replace />;

  return <StaffDashboard userId={user.id} firstName={user.firstName ?? ""} />;
}
